import { render, staticRenderFns } from "./HeaderOnlyLogo.vue?vue&type=template&id=4012a1f3&scoped=true"
var script = {}
import style0 from "./HeaderOnlyLogo.vue?vue&type=style&index=0&id=4012a1f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4012a1f3",
  null
  
)

export default component.exports